// Tiled translucent watermarker for exported images. Applies the
// entitlements.watermark claim (never a hardcoded plan rule).

export function watermarkCanvas(canvas: HTMLCanvasElement, label = 'TRIAL'): void {
  const ctx = canvas.getContext('2d');
  if (!ctx) return;
  const { width, height } = canvas;
  const step = Math.max(180, Math.min(width, height) / 2.2);
  const fontSize = Math.max(18, step / 8);
  ctx.save();
  ctx.globalAlpha = 0.16;
  ctx.translate(width / 2, height / 2);
  ctx.rotate(-Math.PI / 6);
  ctx.font = `600 ${fontSize}px system-ui, sans-serif`;
  ctx.fillStyle = '#1e1f22';
  ctx.textAlign = 'center';
  // cover a generous overlap so rotation stays seamless
  for (let y = -height; y <= height; y += step) {
    for (let x = -width; x <= width; x += step * 1.8) {
      ctx.fillText(label, x, y);
    }
  }
  ctx.restore();
}
